import { t } from '@ardoq/i18n';
import {
  buildRichTextEditorLabels,
  RichTextEditor,
} from '@ardoq/rich-text-editor';
import { CellEditor } from './types';
import { EDITOR_MIN_HEIGHT, RichTextCellEditor } from './RichTextCellEditor';

/**
 * Text paragraph fields are plain rich text. Only the component description
 * gets `ComponentDescriptionEditor` on top — the generation endpoint describes
 * a component, not an arbitrary field.
 */
export const TextAreaEditor: CellEditor<string> = props => {
  const { i18nLocale, richTextEditorConfig } = props.context;
  const fieldName = props.colDef.headerName;
  const title = fieldName
    ? t(
        i18nLocale,
        'inventory:textAreaEditor.title',
        { fieldName },
        'Edit {{fieldName}}'
      )
    : t(i18nLocale, 'inventory:textAreaEditor.titleFallback', 'Edit field');

  return (
    <RichTextCellEditor
      props={props}
      title={title}
      closeLabel={t(
        i18nLocale,
        'inventory:textAreaEditor.close',
        'Close editor'
      )}
    >
      {({ value, onValueChange }) => (
        <RichTextEditor
          autoFocus
          ariaLabel={title}
          content={value}
          onInputChange={onValueChange}
          toolbarExtensions={richTextEditorConfig}
          minHeight={EDITOR_MIN_HEIGHT}
          workspaceId={props.data.rootWorkspace}
          labels={buildRichTextEditorLabels(i18nLocale)}
        />
      )}
    </RichTextCellEditor>
  );
};
